import { Link } from 'react-router-dom';
import type { TaskSummary } from '@agentflow/shared';
import { Badge } from '@/components/ui/badge';
import { StateBadge } from './StateBadge';
import { formatDistanceToNow } from 'date-fns';

export function TaskRow({ task }: { task: TaskSummary }): JSX.Element {
  return (
    <Link
      to={`/tasks/${task.id}`}
      className="block px-4 py-3 hover:bg-accent/50 transition-colors border-b last:border-b-0"
    >
      <div className="flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <div className="font-medium truncate">{task.name}</div>
          <div className="text-xs text-muted-foreground flex gap-2 mt-0.5">
            <span>{task.domain}</span>
            <span>·</span>
            <span>{task.priority}</span>
            <span>·</span>
            <span>updated {formatDistanceToNow(new Date(task.updated_at), { addSuffix: true })}</span>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {task.current_actor && <Badge variant="outline">{task.current_actor}</Badge>}
          <StateBadge state={task.state} pauseReason={task.pause_reason} />
        </div>
      </div>
    </Link>
  );
}
